var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "priority-item queue-failed" }, [
    _c("div", { staticClass: "d-flex align-items-center gap-50" }, [
      _c("span", { staticClass: "far queue-icon" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
            },
          },
          [
            _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
              _c("path", {
                attrs: {
                  d: "M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "currentColor",
                  d: "m10.255 1.387l1.26.756a8.146 8.146 0 0 1 3.48 4.144c.222-.5.486-.985.731-1.475l.981.981C18.909 7.995 21 11.295 21 14.5c0 4.298-2.65 7.023-6.89 7.494l-1.39.154l.304-1.365c.237-1.068.28-1.766.23-2.255c-.06-.615-.352-1.098-.716-1.578c-.348-.46-.693-.921-.969-1.43c-1.135.897-1.575 1.707-1.716 2.374c-.18.854.075 1.727.541 2.659l.822 1.644l-1.826-.203c-2.576-.286-5.114-2.007-6.114-4.518c-1.045-2.627-.306-5.806 3.07-8.732c2.24-1.941 3.426-4.458 3.909-7.357Zm1.332 3.3c-.762 2.14-2.225 4.09-3.932 5.569c-2.911 2.523-3.172 4.844-2.52 6.48c.485 1.22 1.532 2.223 2.773 2.792a4.97 4.97 0 0 1-.012-2.046c.326-1.546 1.438-2.995 3.574-4.33l1.077-.673l.402 1.205c.352 1.056 1.082 1.803 1.653 2.73c.628 1.02.748 2.19.62 3.358C17.842 19.117 19 17.13 19 14.5c0-2.222-1.34-4.402-2.67-6.106c-.548 1.228-1.703 1.66-2.83 2.224V9c0-1.369-.557-3.038-1.913-4.312Z",
                },
              }),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Queue overload!")))]),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "font-weight-bold" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm._f("trans")(
              "We are happy that so many users are using this service and have already dispatched our seal team to order new servers."
            )
          ) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    " +
          _vm._s(_vm._f("trans")("No Credits have been deducted.")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _vm.isFreeUser && !_vm.wasPremiumUser
      ? _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm._f("trans")(
                  "Get a subscription to bypass the queue, enjoy PRO features and process your files faster."
                )
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFreeUser && !_vm.wasPremiumUser
      ? _c(
          "button",
          {
            staticClass: "btn queue-btn bg-warning w-50",
            on: { click: _vm.openPremiumModal },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-right" }),
            _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Get Premium")))]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isFreeUser && _vm.wasPremiumUser
      ? _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm._f("trans")(
                  "Get more Credits to bypass the queue, enjoy PRO features and process your files faster."
                )
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFreeUser && _vm.wasPremiumUser
      ? _c(
          "button",
          {
            staticClass: "btn queue-btn bg-warning w-50",
            on: { click: _vm.openPremiumModal },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-right" }),
            _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Get more Credits")))]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }